import { render } from "./PlatformDefaultTimezone.vue?vue&type=template&id=5c724714&scoped=true"
import script from "./PlatformDefaultTimezone.vue?vue&type=script&lang=js"
export * from "./PlatformDefaultTimezone.vue?vue&type=script&lang=js"

import "./PlatformDefaultTimezone.vue?vue&type=style&index=0&id=5c724714&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c724714"]])

export default __exports__